<template>
  <div>
    <b-btn v-if="$auth.user().isAdmin" @click="showAll = !showAll">показать все поля</b-btn>
    <vue-form-generator ref="form" :schema="schema" :model="model" :options="formOptions"> </vue-form-generator>
    <div v-if="!model.user_id && !$auth.user().isAdmin && objectsWithSubstance && objectsWithSubstance.length > 0">
      Заменить вещество {{ substance.name }} на создаваемую копию у объектов:
      <b-form-checkbox-group
        v-model="model.replaceIds"
        :options="objectsWithSubstance"
        class="mb-3"
        value-field="data"
        text-field="name"
      ></b-form-checkbox-group>
    </div>
    <b-button
      v-if="model.user_id == $auth.user().profile.user_id || $auth.user().isAdmin || !model.id"
      href="#"
      variant="success"
      @click="save()"
      ><span v-if="model.id">Сохранить</span><span v-else>Создать</span></b-button
    >
    <b-btn class="pull-right" @click="saveCopy()" v-if="model.id" variant="success">Создать копию</b-btn>
  </div>
</template>

<script>
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";
const ERROR_MESSAGE = "Необходимо заполнить поле";

export default {
  name: "Liquid",
  components: {
    "vue-form-generator": VueFormGenerator.component,
  },
  props: {
    objectSubstances: Array,
    substance: Object,
    validator: Object,
  },
  computed: {
    objectsWithSubstance() {
      var objects = [];
      if (this.objectSubstances && this.substance) {
        var objs = this.objectSubstances.find((el) => el.id == this.substance.id);
        if (objs) {
          for (var obj of objs.objects) {
            objects.push({ name: obj.name, data: { objId: obj.id, type: obj.type } });
          }
        }
      }
      return objects;
    },
  },
  watch: {
    substance() {
      this.model = Object.assign({}, this.substance);
      this.$set(this.model, "replaceIds", []);
      if (this.objectsWithSubstance) {
        for (let obj of this.objectsWithSubstance) {
          this.model.replaceIds.push(obj.data);
        }
      }
    },
    validator() {
      this.$set(this.model, "validator", this.validator);
      this.$refs.form.validate();
    },
  },
  mounted() {
    this.model = Object.assign({}, this.substance);
    this.$set(this.model, "replaceIds", []);
    if (this.objectsWithSubstance) {
      for (let obj of this.objectsWithSubstance) {
        this.model.replaceIds.push(obj.data);
      }
    }
  },
  data() {
    return {
      showAll: false,
      model: {
        name: "Твердая нагрузка",
        type: 4,
        Q: 0,
        qkr: 0,
        m1: 0,
        replaceIds: [],
        validator: {},
      },
      schema: {
        groups: [
          {
            fields: [
              {
                type: "input",
                inputType: "text",
                label: "Название",
                model: "name",
                required: true,
                validator(value, field, model) {
                  if (!value) return ERROR_MESSAGE;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Массовая скорость выгорания, кг/(м2 с)",
                model: "m1",
                required: true,
                validator(value, field, model) {
                  if (!value) return ERROR_MESSAGE;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Критическая плотность падающих лучистых потоков, кВт/м2",
                model: "qkr",
                required: true,
                validator(value, field, model) {
                  if (!value) return ERROR_MESSAGE;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Низшая теплота сгорания, МДж/кг",
                model: "Q",
                required: true,
                validator(value, field, model) {
                  if (!value) return ERROR_MESSAGE;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
            ],
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
        validateAsync: true,
      },
    };
  },
  methods: {
    async validate() {
      return await this.$refs.form.validate();
    },
    saveCopy() {
      this.validate()
        .then((errorsData) => {
          if (errorsData.length) return;
          this.model.parentId = this.model.id;
          this.model.id = null;
          this.model.name = this.model.name + " (копия)";
          this.model.user_id = this.$auth.user().profile.user_id;
          this.$emit("save", this.model);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    save() {
      this.validate()
        .then((errorsData) => {
          if (errorsData.length) return;
          this.$emit("save", this.model);
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>
